<ng-container *ngIf="enableCalendarAccessibility$ | async; else oldTemplate">
  <label class="h4 text-center custom-font-weight w-100 mt-2 mb-3">{{
    data?.DisplayName || data?.Title
  }}</label>
  <div aria-live="polite" aria-atomic="true" class="sr-only">{{ viewChangeAnnouncement }}</div>
  <section *ngIf="!isUserUnAuthorized" [attr.aria-label]="getCalendarAriaLabel()">
  <div class="row text-center">
    <div class="col-md-4">
      <div class="btn-group">
        <button type="button" mwlCalendarPreviousView class="btn button-action nav-btn" 
          aria-label="Previous period" [view]="view" [(viewDate)]="viewDate" 
          (viewDateChange)="closeOpenMonthViewDay()">Previous</button>
        <button type="button" mwlCalendarToday class="btn button-action nav-btn" 
          aria-label="Go to today" [(viewDate)]="viewDate">Today</button>
        <button type="button" mwlCalendarNextView class="btn button-action nav-btn" 
          aria-label="Next period" [view]="view" [(viewDate)]="viewDate" 
          (viewDateChange)="closeOpenMonthViewDay()">Next</button>
      </div>
    </div>
    <div class="col-md-4">
      <h3 class="custom-title">{{ viewDate | calendarDate: view + "ViewTitle":"en" | titlecase }}</h3>
    </div>
    <div class="col-md-4">
      <div class="btn-group">
        <button type="button" class="btn button-action view-btn" aria-label="Switch to month view" 
          [attr.aria-pressed]="view === CalendarView.Month" (click)="setView(CalendarView.Month)" 
          [class.active]="view === CalendarView.Month">Month</button>
        <button type="button" class="btn button-action view-btn" aria-label="Switch to week view" 
          [attr.aria-pressed]="view === CalendarView.Week" (click)="setView(CalendarView.Week)" 
          [class.active]="view === CalendarView.Week">Week</button>
        <button type="button" class="btn button-action view-btn" aria-label="Switch to day view" 
          [attr.aria-pressed]="view === CalendarView.Day" (click)="setView(CalendarView.Day)" 
          [class.active]="view === CalendarView.Day">Day</button>
      </div>
    </div>
  </div>
  <br />
  <div [ngSwitch]="view" *ngIf="!isUserUnAuthorized">
    <mwl-calendar-month-view
      *ngSwitchCase="CalendarView.Month"
      [viewDate]="viewDate"
      [events]="events"
      [refresh]="refresh"
      [activeDayIsOpen]="activeDayIsOpen"
      (dayClicked)="dayClicked($event.day)"
      (eventClicked)="hourClicked($event)"
      (eventTimesChanged)="eventTimesChanged($event)"
    >
    </mwl-calendar-month-view>
    <mwl-calendar-week-view
      *ngSwitchCase="CalendarView.Week"
      [viewDate]="viewDate"
      [events]="events"
      [refresh]="refresh"
      (eventClicked)="hourClicked($event)"
      (eventTimesChanged)="eventTimesChanged($event)"
    >
    </mwl-calendar-week-view>
    <mwl-calendar-day-view
      *ngSwitchCase="CalendarView.Day"
      [viewDate]="viewDate"
      [events]="events"
      [refresh]="refresh"
      (eventClicked)="hourClicked($event)"
      (eventTimesChanged)="eventTimesChanged($event)"
    >
    </mwl-calendar-day-view>
  </div>
  </section>

  <div *ngIf="isUserUnAuthorized">User is not authorized to see this report</div>
</ng-container>

<ng-template #oldTemplate>
  <label class="h4 text-center custom-font-weight w-100 mt-2 mb-3">{{
    data?.DisplayName || data?.Title
  }}</label>
  <section *ngIf="!isUserUnAuthorized">
  <div class="row text-center">
    <div class="col-md-4">
      <div class="btn-group">
        <button type="button" mwlCalendarPreviousView class="btn button-action nav-btn" 
          [view]="view" [(viewDate)]="viewDate" 
          (viewDateChange)="closeOpenMonthViewDay()">Previous</button>
        <button type="button" mwlCalendarToday class="btn button-action nav-btn" 
          [(viewDate)]="viewDate">Today</button>
        <button type="button" mwlCalendarNextView class="btn button-action nav-btn" 
          [view]="view" [(viewDate)]="viewDate" 
          (viewDateChange)="closeOpenMonthViewDay()">Next</button>
      </div>
    </div>
    <div class="col-md-4">
      <h3 class="custom-title">{{ viewDate | calendarDate: view + "ViewTitle":"en" | titlecase }}</h3>
    </div>
    <div class="col-md-4">
      <div class="btn-group">
        <button type="button" class="btn button-action view-btn" 
          (click)="setView(CalendarView.Month)" 
          [class.active]="view === CalendarView.Month">Month</button>
        <button type="button" class="btn button-action view-btn" 
          (click)="setView(CalendarView.Week)" 
          [class.active]="view === CalendarView.Week">Week</button>
        <button type="button" class="btn button-action view-btn" 
          (click)="setView(CalendarView.Day)" 
          [class.active]="view === CalendarView.Day">Day</button>
      </div>
    </div>
  </div>
  <br />
  <div [ngSwitch]="view" *ngIf="!isUserUnAuthorized">
    <mwl-calendar-month-view
      *ngSwitchCase="CalendarView.Month"
      [viewDate]="viewDate"
      [events]="events"
      [refresh]="refresh"
      [activeDayIsOpen]="activeDayIsOpen"
      (dayClicked)="dayClicked($event.day)"
      (eventClicked)="hourClicked($event)"
      (eventTimesChanged)="eventTimesChanged($event)"
    >
    </mwl-calendar-month-view>
    <mwl-calendar-week-view
      *ngSwitchCase="CalendarView.Week"
      [viewDate]="viewDate"
      [events]="events"
      [refresh]="refresh"
      (eventClicked)="hourClicked($event)"
      (eventTimesChanged)="eventTimesChanged($event)"
    >
    </mwl-calendar-week-view>
    <mwl-calendar-day-view
      *ngSwitchCase="CalendarView.Day"
      [viewDate]="viewDate"
      [events]="events"
      [refresh]="refresh"
      (eventClicked)="hourClicked($event)"
      (eventTimesChanged)="eventTimesChanged($event)"
    >
    </mwl-calendar-day-view>
  </div>
  </section>

  <div *ngIf="isUserUnAuthorized">User is not authorized to see this report</div>
</ng-template>
